import { AxiosError } from "axios";
import {
  call,
  ForkEffect,
  put,
  putResolve,
  takeLeading,
} from "redux-saga/effects";
import { IOrganizatioGetInfoRequest } from "../../redux//organization/types";
import { logoutNew } from "../../redux/auth/actions";
import { setOrganizationIdFromToken } from "../../redux/organization/actions";
import { AxiosCustom } from "../../service/Axios";
import { StorageHelper } from "../../utils/StorageHelper";

import {
  IGetAllNodesInfoRequest,
  IOrganizationGetDetailsRequest,
  ORGANIZATION,
} from "../../redux//organization/types";
import { OrganizationNodeDTO } from "../../redux/organization";
import {
  getAllNodesInfoFailure,
  getAllNodesInfoSuccess,
  getOrganizationInfoFailure,
  getOrganizationInfoSuccess,
} from "../../redux/organization/actions";

export function* getOrganizationWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(ORGANIZATION.GET_ORGANIZATION_REQUEST, getOrganizationSaga);
}

export function* getDetailsWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(ORGANIZATION.GET_DETAILS_REQUEST, getNodeDetailsSaga);
}

function* getOrganizationInfoSaga() {
  try {
    const response = yield call(() => AxiosCustom.getOrganizationInfo());
    const nodes: OrganizationNodeDTO = response.data[0];
    if (nodes === undefined) {
      yield put(logoutNew());
    } else {
      // yield put(correctRegionResult(response.data.link));
    }
    return nodes.self.id;
  } catch (error) {
    const e = error as AxiosError;
    if (e.response.status === 306) {
      window.location.href = e.response.data.redirectTo;
      StorageHelper.instance.UpdateAccessTokenRegion(
        e.response.data.redirectTo
      );
      // yield put(wrongRegionResult(e.response.data.redirectTo));
    }
    yield put(getOrganizationInfoFailure(e.message));
  }
}

function* getOrganizationSaga(action: IOrganizatioGetInfoRequest) {
  try {
    // const organizationID =
    //     action.payload.orgId !== undefined ? action.payload.orgId : yield call(getOrganizationInfoSaga);
    // const organizationID = action.payload;
    // if (organizationID) {
    const responce = yield call(() => AxiosCustom.getOrganizationInfoByID());
    // organizationNode.id = organizationID;
    yield put(getOrganizationInfoSuccess(responce.data));
    const organizationID = yield call(getOrganizationInfoSaga);
    yield put(setOrganizationIdFromToken(organizationID));
    // }
  } catch (error) {
    const e = error as AxiosError;
    yield put(getOrganizationInfoFailure(e.message));
    // yield call(ErrorMonitor, e, ErrorMessages.GET_ORGANIZATION_LESS_AND_INFO);
  }
}

function* getNodeDetailsSaga(action: IOrganizationGetDetailsRequest) {
  // try {
  //     const response = yield call(() => AxiosCustom.getNodeDetails(action.payload.nodeId));
  //     yield putResolve(getNodeDetailsSuccess(response.data, action.payload.nodeId));
  //     return response.data.id;
  // } catch (error) {
  //     const e = error as AxiosError;
  //     yield put(getNodeDetailsFailure(e.message));
  //     yield call(errorMonitor, e);
  // }
}

export function* getAllNodesInfoWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(
    ORGANIZATION.GET_ALL_NODES_INFO_REQUEST,
    getAllNodesDetailsSaga
  );
}

function* getAllNodesDetailsSaga(action: IGetAllNodesInfoRequest) {
  try {
    const response = yield call(() =>
      AxiosCustom.getAllNodesDetails(action.payload)
    );
    yield putResolve(getAllNodesInfoSuccess(response.data));
    return response.data.id;
  } catch (error) {
    const e = error as AxiosError;
    yield put(getAllNodesInfoFailure(e.message));
    // yield call(ErrorMonitor, e, ErrorMessages.GET_ALL_NODES_INFO);
  }
}
